<template>
    <div class="educations">
        <div class="block-label">
            Образование
        </div>
        <ParticipantEducationBlock
            v-for="education in user.userEducation"
            :key="education.id"
            class="margin-row"
            :item="education"
        />
    </div>
</template>

<script>
import ParticipantEducationBlock from './ParticipantEducationBlock';

import { mapGetters, mapActions } from 'vuex';

const getters = [];
const actions = ['loadDictionaryItems'];

export default {
    name: "ParticipantEducations",

    components: {
        ParticipantEducationBlock,
    },

    props: {
        user: {
            type: Object,
            default: () => {},
        },
    },

    created() {
        this.loadDictionaryItems('education_level');
        this.loadDictionaryItems('academic_degree');
    },

    methods: {
        ...mapActions(actions),

    },
};
</script>

<style scoped>

</style>